import styled, { css } from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";
import { IndicatorLayout } from "../consts/indicator-layout";
import { IndicatorDefaultBox } from "./indicator.box";

const IndicatorTextDefaultBox = styled.div<{active?: boolean, displayLayout?: IndicatorLayout}>`
    font-size: ${({displayLayout}) => displayLayout === IndicatorLayout.List ? "1.2rem" : "1rem"};
    color: ${({theme, active}) => active ? theme.colors.bodyText : theme.colors.bodyInfo /* componentTextInfo */};
    transition: color 0.2s ease;
    text-align: center;
    ${({displayLayout}) => displayLayout === IndicatorLayout.List ? css`
        ${IndicatorDefaultBox}:hover & {
            color: ${({theme}) => theme.colors.bodyText};
        }
    ` : "" }

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-size: 1.4rem;
        color: ${({theme}) => theme.colors.bodyText};
    }
`;

const IndicatorTextCasino777Box = styled(IndicatorTextDefaultBox)`
    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        font-weight: 700;
    }
`;

export const IndicatorTextBox = styledByTheme(IndicatorTextDefaultBox)
    .forCasino777(IndicatorTextCasino777Box).apply()
